import PropTypes from 'prop-types';
import {
  Box,
  Drawer,
  Hidden,
  IconButton,
  List,
  Tooltip,
} from '@material-ui/core';
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from '@material-ui/icons';
import DashboardSideBarNavItem from '../DashboardSideBarNavItem';

const SIDEBAR_WIDTH = 256;
const SIDEBAR_COLLAPSED_WIDTH = 72;

const DashboardSidebarComponent = ({
  items,
  isDrawerOpen,
  onDrawerToggle,
  isCollapsed = false,
  onCollapseToggle,
}) => (
  <>
    {/* Mobile: temporary drawer — always full width, no collapse toggle */}
    <Hidden lgUp>
      <Drawer
        anchor="left"
        onClose={onDrawerToggle}
        open={isDrawerOpen}
        variant="temporary"
        PaperProps={{
          sx: {
            width: SIDEBAR_WIDTH,
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <List>
            {items.map((item) => (
              <DashboardSideBarNavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
                active={item.active}
                onClick={item.onClick}
                subItems={item.children}
                badgeCount={item.badgeCount}
              />
            ))}
          </List>
        </Box>
      </Drawer>
    </Hidden>

    {/* Desktop: persistent drawer, width animates between expanded/collapsed */}
    <Hidden mdDown>
      <Drawer
        anchor="left"
        open
        variant="persistent"
        PaperProps={{
          sx: {
            width: isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH,
            top: 64,
            height: 'calc(100% - 64px)',
            overflowX: 'hidden',
            transition: (theme) => theme.transitions.create('width', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.standard,
            }),
          },
        }}
      >
        {/* Collapse/expand toggle anchored at the top */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: isCollapsed ? 'center' : 'flex-end',
            alignItems: 'center',
            px: isCollapsed ? 0 : 1,
            py: 0.5,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Tooltip title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'} placement="right">
            <IconButton size="small" onClick={onCollapseToggle} aria-label="toggle sidebar">
              {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </Tooltip>
        </Box>

        <Box sx={{ p: isCollapsed ? 0.5 : 2 }}>
          <List>
            {items.map((item) => (
              <DashboardSideBarNavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
                active={item.active}
                onClick={item.onClick}
                subItems={item.children}
                badgeCount={item.badgeCount}
                isCollapsed={isCollapsed}
                onExpandSidebar={onCollapseToggle}
              />
            ))}
          </List>
        </Box>
      </Drawer>
    </Hidden>
  </>
);

DashboardSidebarComponent.propTypes = {
  items: PropTypes.array.isRequired,
  isDrawerOpen: PropTypes.bool.isRequired,
  onDrawerToggle: PropTypes.func.isRequired,
  isCollapsed: PropTypes.bool,
  onCollapseToggle: PropTypes.func,
};

export default DashboardSidebarComponent;
